// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"Styles_contentStyles__2mYk9"};